import css from "./Avaliacao.module.css"


function Avaliacao(props) {
    return (
        <div className={`${css.Avaliacao} d-flex flex-lg-column justify-content-lg-center align-items-lg-center gap-4 p-lg-0 p-3`}>
            <div className={css.divimg}>
                <img className={css.imgAvaliacao} src="" alt=""/>
            </div>
            <div className={`${css.campotexto} bg-white px-2 pt-2 text-justify `}>
                <p>
                    {props.txt1}
                </p>
                <p>
                    {props.txt2}
                </p>
            </div>

        </div>
    );
}

export default Avaliacao;
